// extracted by mini-css-extract-plugin
export default {"legend":"WMSMap_legend__wA5I3","map-border":"WMSMap_map-border__JsSM8"};